/**
 * Pack count UI: delegated `change` on `.pb-pack-selector__input` → bubbling `CustomEvent`.
 * Load once per page that uses `pb-pack-size-selector`.
 *
 * Event: `pb:pack-size-change` — detail: { packSize, groupName, fieldset } — packSize 2|3|4|6
 * Bubbles; dispatched on the pack `<fieldset>` (fallback: the `<input>`).
 */
(function () {
  if (window.__pbPackSizeSelectorEventsBound) return;
  window.__pbPackSizeSelectorEventsBound = true;

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || target.nodeName !== 'INPUT' || target.type !== 'radio') return;
    if (!target.classList || !target.classList.contains('pb-pack-selector__input')) return;

    var packFieldset = target.closest ? target.closest('.pb-pack-selector') : null;
    var packSize = parseInt(String(target.value), 10);
    if (Number.isNaN(packSize)) return;

    var packDetail = {
      packSize: packSize,
      groupName: target.name || '',
      fieldset: packFieldset,
    };

    (packFieldset || target).dispatchEvent(
      new CustomEvent('pb:pack-size-change', {
        bubbles: true,
        cancelable: false,
        detail: packDetail,
      })
    );
  });
})();
